import { TEXT_CSS, STYLESHEET, DEVELOPMENT } from '../constants';

export const prependHost = (host: string, path: string): string => {
  return !path.startsWith(host) ? `${host}/${path}` : path;
};

export const appendSlashFromPath = (path: string) => {
  return path.charAt(0) === '/' ? path : `/${path}`;
};

export const hasPath = (pathname: string, paths: string[]) => {
  return paths.some((path) => {
    return pathname.startsWith(appendSlashFromPath(path));
  });
};

export const createLink = (href: string): HTMLLinkElement => {
  const link = document.createElement('link');
  link.href = href;
  link.type = TEXT_CSS;
  link.rel = STYLESHEET;
  return link;
};

export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === DEVELOPMENT || false;
};
